import hand_icon from "./Assets/hand_icon.png";
import arrow from "./Assets/arrow.png";
import hero_image from "./Assets/hero_image.png";
import banner from "../css/banner.css";

export default function Shop() {
  return (
    <div style={banner} className="banner">
      <div className="banner-left">
        <h2>NEW ARRIVALS ONLY</h2>
        <div>
          <div className="hand-icon">
            <p>New</p>
            <img src={hand_icon} alt=" handwaving" />
          </div>
          <p>Collections</p>
          <p>For Everyone</p>
        </div>
        <div className="latest-collection">
          <div>LATEST COLLECTIONS</div>
          <img src={arrow} alt="Arrow icon" />
        </div>
      </div>
      <div className="banner-right">
        <img src={hero_image} alt="" />
      </div>
    </div>
  );
}
